(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["LT-hero-wave"] && !window.DesignMode) return;
  try {
    

const waveTextPath = document.querySelector("#LT-SHW-text-path");

const ltwh = document.documentElement, 
      ltwb = document.body,
      ltwst = 'scrollTop',
      ltwsh = 'scrollHeight';

document.addEventListener("scroll", e => {
  let percent = (ltwh[ltwst]||ltwb[ltwst]) / ((ltwh[ltwsh]||ltwb[ltwsh]) - ltwh.clientHeight) * 100;
  waveTextPath.setAttribute("startOffset", (-percent * 40))
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["LT-oval-marquee"] && !window.DesignMode) return;
  try {
    

function InitOval() {
  let w = ovalwrap.clientWidth;
  let h = ovalwrap.clientHeight;
  ellipse.setAttributeNS(null, "viewBox", `0 0 ${w}  ${h}`);
  let d = `M${9*w / 10},${h / 2}
  A${4 * w / 10},${4 * h / 10} 0 0 1 ${w / 10} ${5 * h / 10}
  A${4 * w / 10},${4 * h / 10} 0 0 1 ${9 * w / 10} ${5 * h / 10} 
  A${4 * w / 10},${4 * h / 10} 0 0 1 ${w / 10} ${5 * h / 10} 
  A${4 * w / 10},${4 * h / 10} 0 0 1 ${9 * w / 10} ${5 * h / 10} `;

  ovalPath.setAttributeNS(null, "d", d);
  let path_length =  ovalPath.getTotalLength();
  let font_size = 100;
  ellipse.style.fontSize = font_size+"px"; 
  while(tp.getComputedTextLength() > path_length / 2 ){
    font_size -=.25;
    ellipse.style.fontSize = font_size+"px";
  }
}

window.setTimeout(function() {
  InitOval();
  window.addEventListener("resize", InitOval, false);
}, 15);

let so = 0;

function MarqueeOval() {
  requestAnimationFrame(MarqueeOval);
  tp.setAttributeNS(null, "startOffset", so + "%");
  if (so >= 50) {
    so = 0;
  }
  so += 0.02;
}

MarqueeOval();

  } catch(e) { console.error(e); }
})();
      })();
